// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1ZN7M","header":"MergedInvoice_header__MX4--"};